import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import { useNavigate } from 'react-router-dom';
import userIcon from '../../../assets/images/user.png';
import './style.scss';
import { button, textInput, view } from '../../../components';
var mobile = require('is-mobile');

const ViewProject = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    useEffect(() => {
    }, []);

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='ViewProject-Container'>
 
            </div>
        )
    }
})

export default ViewProject;